import React, { useState } from 'react';
import { Modal, Tooltip } from 'antd';
import { Button } from '@digital/ui';
import { useRecoilValue } from 'recoil';
import { dadosGeraisState } from '../atoms';
import { AtivarDemandaConsultivaCommand } from '@app/api/sas/ordemCompra';
import CurrencyInput2 from '@app/components/CurrencyInput2';

export const ButtonModalAtivarDemanda = () => {
  const [open, setOpen] = useState(false);
  const [confirmEmailVisible, setConfirmEmailVisible] = useState(false);
  const [loading, setLoading] = useState(false);
  const [valor, setValor] = useState<number | undefined>(undefined);
  const [enviarEmail, setEnviarEmail] = useState<boolean | null>(null);

  const dadosGerais = useRecoilValue(dadosGeraisState);
  const title = 'Ativar Demanda';

  const handleConfirm = async (enviar: boolean) => {
    if (valor === undefined || valor === null || valor === 0) {
      Modal.error({
        title: 'Campo obrigatório',
        content: 'Por favor, preencha o campo valor.',
      });
      return;
    }

    setEnviarEmail(enviar);
    setConfirmEmailVisible(false);
    setLoading(true);

    try {
      const result: any = await AtivarDemandaConsultivaCommand({ 
        ordemcompraId: dadosGerais.id,
        valor: valor,
        enviarEmail: enviar // envia flag pro backend
      });

      if (result.valid) {
        Modal.success({
          title: `Demanda ${result.identificadorDemanda} ativada com sucesso!`,
          onOk: () => window.location.reload(),
        });
      } else {
        Modal.error({
          title: 'Falha ao Ativar Demanda!',
          content: 'Ocorreu um erro inesperado.',
        });
      }
    } catch (error) {
      Modal.error({
        title: 'Erro ao processar requisição',
        content: 'Verifique sua conexão e tente novamente.',
      });
    } finally {
      setLoading(false);
      setOpen(false);
      setValor(undefined);
      setEnviarEmail(null);
    }
  };

  const handlePreConfirm = () => {
    if (valor === undefined || valor === null || valor === 0) {
      Modal.error({
        title: 'Campo obrigatório',
        content: 'Por favor, preencha o campo valor.',
      });
      return;
    }
    // Abre o segundo modal de confirmação de envio de e-mail
    setConfirmEmailVisible(true);
  };

  return (
    <>
      <Tooltip title={title}>
        <Button
          onClick={() => setOpen(true)}
          className={`button-modal-acoes-gerais ${
            dadosGerais.demandaAtiva == true ? 'button-modal-acoes-gerais-disabled' : ''
          }`}
          disabled={dadosGerais.demandaAtiva}>
          ATIVAR DEMANDA
        </Button>
      </Tooltip>

      {/* MODAL PRINCIPAL */}
      {/* @ts-ignore */}
      <Modal
        visible={open}
        title={title}
        onCancel={() => {
          setOpen(false);
          setValor(undefined);
        }}
        footer={[
          <Button key="cancel" onClick={() => {
            setOpen(false);
            setValor(undefined);
          }} title="Cancelar" type="link" />,
          <Button key="confirm" title="Confirmar" type="primary" onClick={handlePreConfirm} />,
        ]}
      >
        <div>
          <p style={{ marginBottom: 16 }}>Tem certeza que deseja ativar a demanda?</p>
          <div>
            <label style={{ display: 'block', marginBottom: 8 }}>
              Valor Sugestivo da Demanda Consultiva <span style={{ color: 'red' }}>*</span>
            </label>
            <CurrencyInput2 
              id='mrn-input-valor' 
              style={{ width: '100%' }}
              value={valor}
              onChange={(e) => setValor(e ? Number(e) : undefined)}
            />
          </div>
        </div>
      </Modal>

      {/* SEGUNDO MODAL - PERGUNTA SOBRE E-MAIL */}
      <Modal
        visible={confirmEmailVisible}
        title="Enviar E-mail ao Demandante?"
        onCancel={() => setConfirmEmailVisible(false)}
        footer={[
          <Button key="no" title="Não Enviar" type="default" onClick={() => handleConfirm(false)} />,
          <Button key="yes" title="Enviar E-mail" type="primary" loading={loading} onClick={() => handleConfirm(true)} />,
        ]}
      >
        <p>Deseja enviar um e-mail notificando o demandante sobre a ativação da demanda?</p>
      </Modal>
    </>
  );
};
